export const STORAGE_NOTIFICATIONSKEY = "notifications";
